
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ReasonStatusDialog extends Serenity.EntityDialog<ReasonStatusRow, any> {
        protected getFormKey() { return ReasonStatusForm.formKey; }
        protected getIdProperty() { return ReasonStatusRow.idProperty; }
        protected getLocalTextPrefix() { return ReasonStatusRow.localTextPrefix; }
        protected getNameProperty() { return ReasonStatusRow.nameProperty; }
        protected getService() { return ReasonStatusService.baseUrl; }
        protected getDeletePermission() { return ReasonStatusRow.deletePermission; }
        protected getInsertPermission() { return ReasonStatusRow.insertPermission; }
        protected getUpdatePermission() { return ReasonStatusRow.updatePermission; }
        protected useViewMode() { return true; }

        protected form = new ReasonStatusForm(this.idPrefix);
        constructor() {
            super();
            this.form.Type.changeSelect2(e => {
                var fixedtype = this.form.Type.value;

                if (fixedtype == "REASON") {
                    this.form.TypeId.cascadeField = "FixedType";
                    this.form.TypeId.cascadeValue = "REASON_TYPE";
                } else if (fixedtype == "STATES") {
                    this.form.TypeId.cascadeField = "FixedType";
                    this.form.TypeId.cascadeValue = "STATES_TYPE";
                }
            })
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            if (this.entity.IsDefault == true) {
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
                q.showAndDisableField(this.form.Type);
                q.showAndDisableField(this.form.TypeId); 
                //q.showAndEnableField(this.form.TypeDescription);
                //q.showAndEnableField(this.form.Notification);
            } else {
                if (!self.isEditMode())
                    return;
                self.editClicked = true; 
                self.updateInterface();
                self.updateTitle();

            } 
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            if (this.entity.IsDefault == true) {
                Q.alert("This is a Default Value. Cannot Delete!");
                return;
            } else {
                ReasonStatusService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

    }
}